module.exports = __webpack_public_path__ + "img/knight3_04.3eadc2b8.jpg";